import { useFormik } from "formik";
import {
  AdminLeadControllerCreateResponse,
  useAdminLeadControllerCreate,
} from "service";
import { AdminPostLeadReqDto } from "service/api/estabrookSchemas";
import { queryKeyFn } from "service/api/estabrookContext";
import { toFormikValidationSchema } from "zod-formik-adapter";
import { queryClient } from "@/query-client";
import { leadFormSchema } from "../utils/lead-form-schema";

const initialValues: AdminPostLeadReqDto = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "+",
  address: "",
};

const useLeadForm = (
  onFormSuccess: (data: AdminLeadControllerCreateResponse) => void,
) => {
  const { mutate, isLoading } = useAdminLeadControllerCreate({
    onSuccess: (data) => {
      queryClient.invalidateQueries(
        queryKeyFn({
          path: "/api/v1/admin/leads",
          operationId: "adminLeadControllerGetAll",
          variables: {},
        }),
      );
      onFormSuccess(data);
    },
  });

  const leadForm = useFormik<AdminPostLeadReqDto>({
    initialValues,
    validationSchema: toFormikValidationSchema(leadFormSchema),
    onSubmit: (values) => {
      mutate({ body: { ...values } });
    },
  });

  return { leadForm, isLoading };
};

export default useLeadForm;
